import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Initialize i18n before rendering
import './lib/i18n';

// Import test utilities for i18n (Phase 1 - Development only)
import './utils/testLanguageSystem';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
